declare namespace $ {

	type $shm_hitalama_textarea__hint_shm_hitalama_map_widget_float_code_html_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_code_html['textarea_hint'] >
		,
		ReturnType< $shm_hitalama_textarea['hint'] >
	>
	type $shm_hitalama_textarea__sidebar_showed_shm_hitalama_map_widget_float_code_html_2 = $mol_type_enforce<
		boolean
		,
		ReturnType< $shm_hitalama_textarea['sidebar_showed'] >
	>
	type $shm_hitalama_textarea__value_shm_hitalama_map_widget_float_code_html_3 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_code_html['code'] >
		,
		ReturnType< $shm_hitalama_textarea['value'] >
	>
	type $shm_hitalama_textarea__value_click_shm_hitalama_map_widget_float_code_html_4 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_code_html['widget_value_click'] >
		,
		ReturnType< $shm_hitalama_textarea['value_click'] >
	>
	type $shm_hitalama_textarea__spellcheck_shm_hitalama_map_widget_float_code_html_5 = $mol_type_enforce<
		boolean
		,
		ReturnType< $shm_hitalama_textarea['spellcheck'] >
	>
	type $shm_hitalama_textarea__submit_shm_hitalama_map_widget_float_code_html_6 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_code_html['run_click'] >
		,
		ReturnType< $shm_hitalama_textarea['submit'] >
	>
	type $shm_hitalama_textarea__style_shm_hitalama_map_widget_float_code_html_7 = $mol_type_enforce<
		({ 
			'fontSize': ReturnType< $shm_hitalama_map_widget_float_code_html['font_size_px'] >,
		}) 
		,
		ReturnType< $shm_hitalama_textarea['style'] >
	>
	type $shm_hitalama_map_widget_float_code_html_bench__widget_shm_hitalama_map_widget_float_code_html_8 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_code_html['widget'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_code_html_bench['widget'] >
	>
	type $shm_hitalama_map_widget_float_code_html_bench__map_shm_hitalama_map_widget_float_code_html_9 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_code_html['map'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_code_html_bench['map'] >
	>
	type $shm_hitalama_map_widget_float_code_html_bench__Map_page_shm_hitalama_map_widget_float_code_html_10 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_code_html['Map_page'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_code_html_bench['Map_page'] >
	>
	type $shm_hitalama_map_widget_float_code_html_bench__run_click_shm_hitalama_map_widget_float_code_html_11 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_code_html['run_click'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_code_html_bench['run_click'] >
	>
	export class $shm_hitalama_map_widget_float_code_html extends $shm_hitalama_map_widget_float_code {
		widget_value_click( id: any, next?: any ): any
		Textarea( ): $shm_hitalama_textarea
		Bench( ): $shm_hitalama_map_widget_float_code_html_bench
		textarea_hint( ): string
		code_content( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=html.view.tree.d.ts.map